module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/._babel-runtime@6.23.0@babel-runtime/core-js/symbol.js
 ** module id = 371
 ** module chunks = 0 1
 **/